import axios from "axios";
import { httpDelete, httpGet, httpPatch, httpPost } from "../connection.js";

// Get Notes
async function getNotes(values = {}) {
  return await httpGet(`/notes`, values);
}

// Get Notes with complex query
async function query(query) {
  return await httpPost("/notes/query", query);
}

// Create Note
async function createNote(values) {
  return await httpPost(`/notes`, values);
}

// Update Note
async function updateNote(values) {
  return await httpPatch(`/notes`, values);
}

// Delete Note
async function deleteNote(values = {}) {
  return await httpDelete(`/notes/${values.uuid}`);
}

async function exportNotes(values = {}) {
  return await httpPost(`/notes/export`, values);
}

async function getUploadUrl(values = {}) {
  return await httpPost(`/notes/get-upload-url`, values);
}

async function uploadImage(values = {}) {
  return await axios.put(values.url, values.file, {});
}

async function addAttachment(values = {}) {
  return await httpPost(`/notes/add-attachment`, values);
}

// Download a pasted external image server-side and store it as a note image.
// Failures are silent in the UI (the editor drops the placeholder), so no error toast.
async function downloadImageFromUrl(values = {}) {
  return await httpPost(`/notes/download-image-from-url`, values, {
    skipErrorToast: true,
  });
}

async function getTemplates(values = {}) {
  return await httpGet(`/notes/templates`, values);
}

async function updateTemplate(values = {}) {
  return await httpPatch(`/notes/templates`, values);
}

async function createTemplate(values = {}) {
  return await httpPost(`/notes/templates`, values);
}

async function deleteTemplate(values = {}) {
  return await httpDelete(`/notes/templates/${values.uuid}`);
}

async function getNoteObjectLinks(values = {}) {
  return await httpGet(`/notes/object-links`, values);
}

async function createNoteObjectLink(values = {}) {
  return await httpPost(`/notes/object-links`, values);
}

async function deleteNoteObjectLink(values = {}) {
  return await httpDelete(`/notes/object-links/${values.uuid}`);
}

async function getNoteUsers(values = {}) {
  return await httpGet(`/notes/note-users`, values);
}

async function getNoteVersions(values = {}) {
  return await httpGet(`/notes/${values.note_uuid}/versions`, values);
}

// Get specific note version content (performance optimized - only fetches content for selected version)
async function getNoteVersionContent(values = {}) {
  return await httpGet(`/notes/${values.note_uuid}/versions`, {
    ...values,
    include_content: true,
    version_uuid: values.version_uuid,
  });
}

const MonolithNotesAPI = {
  getNotes,
  query,
  createNote,
  updateNote,
  deleteNote,
  exportNotes,
  getUploadUrl,
  uploadImage,
  addAttachment,
  downloadImageFromUrl,
  getTemplates,
  updateTemplate,
  deleteTemplate,
  createTemplate,
  getNoteObjectLinks,
  createNoteObjectLink,
  deleteNoteObjectLink,
  getNoteUsers,
  getNoteVersions,
  getNoteVersionContent,
};

export default MonolithNotesAPI;
